export const handleMultipleJsonUpload = (event, setJsonData) => {
    const files = Array.from(event.target.files);
    const allJsons = [];
    let filesLoaded = 0;

    files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const parsed = JSON.parse(e.target.result);
                if (Array.isArray(parsed)) {
                    allJsons.push(...parsed);
                } else {
                    allJsons.push(parsed);
                }
            } catch (err) {
                console.error('Invalid JSON in file:', file.name, err);
                alert(`Invalid JSON in file: ${file.name}`);
            }

            filesLoaded++;
            if (filesLoaded === files.length) {
                setJsonData(allJsons); // ✅ finally update the state
            }
        };
        reader.readAsText(file);
    });
};
